import React, { useState } from "react";
import HeaderIndex from "./Header/HeaderIndex";

const MainLayout = (props) => {

  return (
    <>
      {/* <HeaderIndex /> */}
      <div className="main-wrapper">
        {props.children}
      </div>
      {/* <EmptyFooter /> */}
    </>
  );
};

export default MainLayout;
